import { useState } from 'react';
import { mag } from '@vip/shared';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '../auth/useAuth';
import { ArchiefTab } from './ArchiefTab';
import { OpdrachtenTab } from './OpdrachtenTab';
import { PersonenTab } from './PersonenTab';
import { UitnodigingenTab } from './UitnodigingenTab';

/**
 * Personen: wie er zijn, op welke opdracht, wie is uitgenodigd en wie er niet
 * meer bij hoort.
 *
 * Wie wie begeleidt stond hier als vijfde tabblad. Dat is een eigen scherm
 * geworden in de zijbalk: het koppelen loopt over de opdrachten heen en het is
 * een andere taak dan het bijhouden van de administratie.
 *
 * Anders dan de instellingen staat dit scherm binnen `Layout`, mét de zijbalk.
 * Dit is werk en geen bijstellen: de Admin komt hier om mensen toe te voegen
 * en op orde te houden, en dat is dezelfde soort taak als het dashboard
 * ernaast.
 *
 * Het paneel Toegang uit de instellingen is hierin opgegaan. Twee plekken waar
 * je aan dezelfde mensen kunt zitten is er één te veel.
 *
 * Een buddy komt hier ook, maar voor een korter scherm: hij ziet zichzelf en de
 * mensen die hij begeleidt. Uitnodigingen en Archief gaan over toegang en
 * blijven bij de Admin; de opdrachten staan er wel, want die heeft hij nodig
 * om zijn gecoachten neer te zetten.
 */
export function PersonenPagina() {
  const [actief, setActief] = useState('personen');
  const { user } = useAuth();
  const magBeheren = mag(user?.rechten, 'persoon:manage');

  return (
    <Tabs className="flex flex-col gap-6" onValueChange={setActief} value={actief}>
      <TabsList>
        <TabsTrigger value="personen">Personen</TabsTrigger>
        <TabsTrigger value="opdrachten">Opdrachten</TabsTrigger>
        {magBeheren && <TabsTrigger value="uitnodigingen">Uitnodigingen</TabsTrigger>}
        {magBeheren && <TabsTrigger value="archief">Archief</TabsTrigger>}
      </TabsList>

      {/* `TabsContent` hangt de inhoud uit de boom zolang een tabblad niet
          actief is, dus de uitvraag van de historie loopt pas als je het
          archief opent. */}
      <TabsContent value="personen">
        <PersonenTab />
      </TabsContent>
      <TabsContent value="opdrachten">
        <OpdrachtenTab />
      </TabsContent>
      {magBeheren && (
        <TabsContent value="uitnodigingen">
          <UitnodigingenTab />
        </TabsContent>
      )}
      {magBeheren && (
        <TabsContent value="archief">
          <ArchiefTab />
        </TabsContent>
      )}
    </Tabs>
  );
}
